module.exports = __webpack_public_path__ + "static/media/background-404-80.3268198a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-404-80.jpg
// module id = 1704
// module chunks = 2